<template>
  <div class="team-intro-content">
    <title-bar
      title-light="团队"
      title="介绍"
      desc="优秀的管理团队，经验丰富"
    ></title-bar>
    <team-intro-card
      label="李泽"
      desc="CEO"
    >
      <template #intro>
        <div>李泽先生拥有10年以上统计部门工作经历，期间先后参与经济普查、农业普查及人口普查等三大普查，独立负责固定资产投资、房地产、建筑业等专业统计工作；作为第三方机构，主持调查对象超过20000家的污染源普查清查建库项目。</div>
      </template>
      <template #img>
        <img
          style="width: 100%; height: 100%;"
          src="@/assets/images/about-us/person-one.png"
          alt=""
        >
      </template>
    </team-intro-card>
    <team-intro-card
      type="right"
      label="王小臣"
      desc="CTO"
    >
      <template #intro>
        <div>
          <p>浙江工业大学硕士，5年以上软件开发项目主持经验，高级软件开发工程师，先后主持开发实验室信息化管理系统、城市垃圾处理智能系统、医学检验实验室信息系统、统计考试教育系统、科技统计台账系统等多个先进的信息技术系统。带领团队曾达到14人，开发的软件服务对象超过200万人。</p>
          <p>专业特长：</p>
          <p>擅长PHP编程语言，对Laravel框架、ThinkPHP、Swoole 等主流 PHP 框架有深入研究；</p>
          <p>擅长Vue.js前端框架，对React、Angular框架有深入研究；</p>
          <p>擅长MySQL关系数据库设计和性能调优。</p>
          <p>熟悉Python数据分析运用、scrapy等主流爬虫技术、高性能 GoLang 开发和微服务框架等；</p>
          <p>对区块链（blockchain）技术、以太坊（Ethereum）solidity DApp 编程有深入研究。</p>
        </div>
      </template>
      <template #img>
        <img
          style="width: 100%; height: 100%;"
          src="@/assets/images/about-us/person-two.png"
          alt=""
        >
      </template>
    </team-intro-card>
    <team-intro-card label="稳定的调查员队伍">
      <template #intro>
        <div>
          我司拥有十位严格招聘，精心培养的专业调查项目负责人能负责各项调查项目。还有：<br />
          1、公司委托培养的学生调查员团队，主要特点是工作细致认真，责任性强；<br />
          2、公司维护的长期兼职调查员团队，主要特点是机动性强，有重要的补充作用；<br />
          3、公司临时聘用的有普查经验的社会调查员，主要特点是普查工作经验丰富；<br />
          4、有偿聘用的社区人员及网格人员，主要特点是对当地情况熟悉、入户更顺利。
        </div>
      </template>
      <template #img>
        <div style="padding: 46px 13px 0;">
          <img
            style="width:100%;height:164px;margin-bottom:40px;"
            src="@/assets/images/about-us/door.jpg"
            alt="公司门面图"
          >
          <img
            style="width:100%;height:213px;"
            src="@/assets/images/about-us/company.jpg"
            alt="公司全景图"
          >
        </div>
      </template>
    </team-intro-card>
  </div>
</template>

<script>
import TitleBar from '@/components/TitleBar'
import TeamIntroCard from './components/TeamIntroCard'
export default {
  name: 'TeamIntroContent',
  components: {
    TitleBar,
    TeamIntroCard
  }
}
</script>

<style lang="less" scoped>
.team-intro-content {
  .title-bar {
    padding: 70px 0;
  }
  .team-intro-card ~ .team-intro-card {
    margin-top: 70px;
  }
}
</style>
